import clsx from 'clsx';

import { FaGithub, FaLinkedin, FaStrava, GmailIcon } from './icons';
import styles from './socialFollow.module.css';

const SocialFollow = ({ children }: { children: React.ReactNode }) => {
  return (
    <footer className={styles.socialFooter}>
      <div style={{ width: '300px' }} />
      <div className={styles.socialContainer}>
        <a
          href="mailto:benoit.grasset@gmail.com"
          className={clsx(styles.gmail, styles.social)}
        >
          <GmailIcon />
        </a>
        <a
          href="https://github.com/benoitgrasset"
          className={clsx(styles.github, styles.social)}
        >
          <FaGithub size={30} />
        </a>
        <a
          href="https://www.strava.com/athletes/36655238"
          className={clsx(styles.strava, styles.social)}
        >
          <FaStrava size={30} />
        </a>
        <a
          href="https://www.linkedin.com/in/benoit-grasset-330304103/"
          className={clsx(styles.linkedin, styles.social)}
        >
          <FaLinkedin size={30} />
        </a>
      </div>
      {children}
    </footer>
  );
};

export default SocialFollow;
